<script>
import baseMixin from '@/mixins/baseMixin'

export default {
  name: 'BookingDetailsRequestAlert',
  mixins: [baseMixin],
  props: {
    booking: {
      type: Object,
      required: true,
    },
  },
}
</script>

<template>
  <v-alert color="primary" text>
    <div class="d-flex align-center">
      <v-icon left class="mr-4" color="primary">mdi-information</v-icon
      >{{ $t('booking.details.pendingApprovalAlertText') }}
    </div>
  </v-alert>
</template>
